import { sendToTelemetry, TLTRY_DEFAULTS } from 'legacy-src/utility/telemetry';

const sendTelemetryEvent = (
  subjectId,
  type,
  videosNumber,
  classesAssignedToNumber,
) => {
  const eventType =
    type === 'subunit' ? 'assign_videos_subunit' : 'assign_videos_unit';
  const { importId: cbUserId, initId: amUserId } = window.current_user || {};

  const telemetryData = {
    app: 'units',
    event_type: eventType,
    context: {
      subjectId,
      videosNumber,
      classesAssignedToNumber,
    },
    user: {
      am_user_id: amUserId,
      cb_user_id: cbUserId,
    },
  };
  sendToTelemetry(Object.assign(telemetryData, TLTRY_DEFAULTS[0]));
};

export default sendTelemetryEvent;
